import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Datetime from "react-datetime";

class CustomTimerange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // show utc time as initial values
      start: props.start || moment().utc(),
      end: props.end || moment().utc()
    };
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
  }

  getTimeFormat = () => {
    if (this.props.type === "date") return false;
    return "HH:mm UTC";
  };

  handleChangeStart(start) {
    this.setState({ start });
  }

  handleChangeEnd(end) {
    this.setState({ end });
  }

  render() {
    const { start, end } = this.state;
    const {
      onApply,
      startInputProps,
      endInputProps,
      btnGroupProps,
      className
    } = this.props;
    return (
      <div className={className}>
        <div className="rdt__label">From:</div>
        <Datetime
          closeOnSelect
          inputProps={{
            ...startInputProps,
            "data-testid": "custom_timerange_start"
          }}
          dateFormat="YYYY-MM-DD"
          timeFormat={this.getTimeFormat()}
          initialValue={start}
          onChange={this.handleChangeStart}
        />
        <div className="rdt__label">To:</div>
        <Datetime
          closeOnSelect
          inputProps={{
            ...endInputProps,
            "data-testid": "custom_timerange_end"
          }}
          dateFormat="YYYY-MM-DD"
          timeFormat={this.getTimeFormat()}
          initialValue={end}
          onChange={this.handleChangeEnd}
        />
        <div {...btnGroupProps}>
          <Button
            variant="prompt-primary"
            className="btn--short"
            onClick={() => onApply({ start, end })}
          >
            Apply
          </Button>
        </div>
      </div>
    );
  }
}

CustomTimerange.propTypes = {
  btnGroupProps: PropTypes.shape({
    className: PropTypes.string
  }),
  startInputProps: PropTypes.shape(),
  endInputProps: PropTypes.shape(),
  start: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  end: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onApply: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.oneOf(["time", "date"])
};

CustomTimerange.defaultProps = {
  btnGroupProps: {
    className: "pull-right"
  },
  startInputProps: {},
  endInputProps: {},
  onApply: () => {}
};

export default CustomTimerange;
